import { render, staticRenderFns } from "./UsersAchievements.vue?vue&type=template&id=0fd22afa&"
import script from "./UsersAchievements.vue?vue&type=script&lang=js&"
export * from "./UsersAchievements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports